var map = {
	"./BG_2.jpg": 99227,
	"./blue-clouds-bg.png": 89489,
	"./bright-orange-bg.png": 10470,
	"./chalk-board.png": 83627,
	"./diversity-yellow-bg.png": 88422,
	"./energy-bg.png": 38231,
	"./forces-bg.png": 61453,
	"./green-organisms-bg.png": 6365,
	"./hallway-bg.png": 24261,
	"./home-page-student-bg.png": 17051,
	"./persian-green-fallow-bg.png": 47436,
	"./purple-galaxy-background.png": 32708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92181;